import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchProformaById } from '../../slices/proforma';
import logo from '../../Images/logo.svg';
import dayjs from 'dayjs';
import { useParams } from 'react-router';
import { fetchWorkOrderById } from '../../slices/work-order';
import CompanyLogo from '../../Common/CompanyLogo';

function PrintProforma() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { activeProfileRecord, status } = useSelector(state => state.proforma);
  const { data: settingData } = useSelector(state => state.setting);
  const [isTransforming, setIsTransforming] = useState(false);
  const [workOrderDetail, setWorkOrderDetail] = useState([]);
   const companyLogo = settingData?.company_settings?.company_logo || logo;

  useEffect(() => {
    if (id) {
      dispatch(fetchProformaById({ id }))
        .then(response => {
          
          dispatch(
            fetchWorkOrderById(response?.payload?.data?.workorder))
            .then(response => {
              setWorkOrderDetail(response?.payload?.data);
            })
            .catch(error => {
              console.error('View Quotation Failed:', error);
            });
        })
        .catch(error => {
          console.error('View Quotation Failed:', error);
        });
    }
  }, [dispatch, id]);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
               * {
           
            box-sizing: border-box !important;
            font-family: -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji !important;
          }
          
          body {
            font-family: Arial, sans-serif !important;
            font-size: 10px !important;
            line-height: 1.4 !important;
            color: #000 !important;
          }
          
          .invoice-container {
            background: white !important;
            padding: 20px !important;
            margin: 5px !important;
          }
          
         .header-section {
            display: flex !important;
            justify-content: space-between !important;
            align-items: flex-start !important;
            padding-bottom: 10px !important;
            margin-bottom: 20px !important;
          }
          
           .logo-section {
            flex: 0 0 auto !important;
          }
          
          .logo {
            width: 120px !important;
            height: auto !important;
          }
          
          .title-section {
            flex: 0 0 auto !important;
            text-align: right !important;
          }
          
          .invoice-title {
            font-size: 28px !important;
            font-weight: 300 !important;
            color: #12406a !important;
            margin: 0 !important;
          }
          
          .info-section {
            display: flex !important;
            justify-content: end !important;
            margin-bottom: 20px !important;
          }
          
          .info-left {
            flex: 1 !important;
            max-width: 300px !important;
          }
          
          .info-right {
            flex: 1 !important;
            text-align: right !important;
          }
          
          .info-table {
            border-collapse: collapse !important;
            width: 100% !important;
            font-size: 18px !important;
          }
          
          .info-table td {
            border: 1px solid #dee2e6 !important;
            padding: 4px 8px !important;
            vertical-align: top !important;
          }
          
          .info-label {
            font-weight: bold !important;
            white-space: nowrap !important;
            padding-right: 10px !important;
          }
          
          .address-section {
            display: flex !important;
            gap: 20px !important;
            margin-bottom: 20px !important;
          }
          
          .address-box {
            flex: 1 !important;
            border: 1px solid #ccc !important;
          }
          
          .address-header {
            background: #12406a !important;
            color: white !important;
            padding: 8px 12px !important;
            font-weight: bold !important;
            font-size: 16px !important;
          }
          
          .address-content {
            padding: 12px !important;
            font-size: 16px !important;
            line-height: 1.5 !important;
            min-height: 80px !important;
          }
          
          .main-table {
            width: 100% !important;
            border-collapse: collapse !important;
            font-size: 14px !important;
            margin-bottom: 20px !important;
          }
          
          .main-table th,
          .main-table td {
            border: 1px solid #dee2e6 !important;
            padding: 6px 4px !important;
            text-align: center !important;
            vertical-align: middle !important;
          }
          
          .main-table th {
            background: transparent !important;
            color: black !important;
            font-weight: bold !important;
            font-size: 16px !important;
          }
          
          .main-table .section-image {
            width: 90px !important;
            height: 90px !important;
            object-fit: contain !important;
          }
          
          .total-row {
            font-weight: bold !important;
            background: #f9f9f9 !important;
          }
          
          .amount-section {
            text-align: right !important;
            margin-bottom: 20px !important;
          }
          
          .footer-section {
            display: flex !important;
            gap: 20px !important;
            margin-bottom: 30px !important;
          }
          
          .terms-box,
          .bank-box {
            flex: 1 !important;
            border: 1px solid #ccc !important;
          }
          
          .terms-header,
          .bank-header {
            background: #12406a !important;
            color: white !important;
            padding: 8px 12px !important;
            font-weight: bold !important;
            font-size: 15px !important;
          }
          
          .terms-content,
          .bank-content {
            padding: 2px !important;
            font-size: 13px !important;
            line-height: 1.6 !important;
          }
          
          .signature-section {
            display: flex !important;
            justify-content: space-around !important;
            margin: 40px 0 20px !important;
          }
          
          .signature-box {
            text-align: center !important;
            font-weight: bold !important;
            font-size: 16px !important;
          }
          
          .company-footer {
            text-align: center !important;
            border-top: 1px solid #ccc !important;
            padding-top: 10px !important;
            font-size: 11px !important;
            color: #666 !important;
          }
          
          .print-button {
            background: #12406a !important;
            color: white !important;
            border: none !important;
            padding: 10px 20px !important;
            font-size: 14px !important;
            border-radius: 4px !important;
            cursor: pointer !important;
            margin: 20px auto !important;
            display: block !important;
          }
          
          .terms-content {
            font-size: 14px !important;
            line-height: 1.1 !important;
            color: #222 !important;
            flex: 1 !important;
            margin: 0 !important;
            padding: 5px !important;
          }
          
          @media print {
            body {
                font-size: 13px !important;
                margin: 0 !important;
                background: white !important;
                color: black !important;
            }
            
            @page {
                size: A4 portrait !important;  
                margin: 12mm !important;
            }
            
            .invoice-container {
                margin: 0 !important;
                padding: 10px !important;
                box-shadow: none !important;
            }
            
            .print-button {
                display: none !important;
            }

            .invoice-title {
                font-size: 20px !important;
            }

            .info-table {
              width: 100% !important;
              font-size: 15px !important;
            }
            
            .logo {
                width: 140px !important;
            }
            
            .main-table {
                font-size: 15px !important;
            }

            .terms-header,
            .bank-header {
              background: #12406a !important;
              color: white !important;
              padding: 8px 12px !important;
              font-weight: bold !important;
              font-size: 14px !important;
            }
          
            .terms-content,
            .bank-content {
              padding: 2px !important;
              font-size: 13px !important;
              line-height: 1.6 !important;
            }
            
            .main-table th {
                font-size: 15px !important;
                background: #f0f0f0 !important;
                color: black !important;
            }
            
            .main-table .section-image {
                width: 60px !important;
                height: 60px !important;
            }
            
            .address-header,
            .bank-header {
                background: #12406a !important;
                color: white !important;
            }
            
            .address-content,
            .bank-content {
                font-size: 15px !important;
            }
            
            .terms-fullpage {
                page-break-before: always !important;
                padding: 10px !important;
                font-size: 9px !important;
            }
            
            .terms-content {
              font-size: 10px !important;
              line-height: 1.1 !important;
              color: #222 !important;
              flex: 1 !important;
              margin: 0 !important;
              padding: 5px !important;
            }
            
            .signature-section {
                margin: 50px 0 10px !important;
            }
            
            thead {
                display: table-header-group !important;
            }
            
            tbody {
                display: table-row-group !important;
            }
            
            tr {
                page-break-inside: avoid !important;
            }
            
            .no-print {
                display: none !important !important;
            }
          }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const getDefaultInvoiceData = () => ({
    date: 'N/A',
    piNo: 'N/A',
    poNo: 'N/A',
    workOrderNo: 'N/A',
    billTo: {
      name: 'N/A',
      company: 'N/A',
      address: 'N/A',
    },
    shipTo: {
      name: 'N/A',
      company: 'N/A',
      address: 'N/A',
    },
    items: [],
    totals: {
      pieces: '0',
      weight: '0.00',
      basicAmount: '0.00',
      gst: '0.00',
      total: '0.00',
    },
    freightCharges: '0.00',
    advanceAmount: '0.00',
    totalPayable: '0.00',
    termsAndConditions: '',
    bankDetails: {
      gstNo: 'N/A',
      bankName: 'N/A',
      branch: 'N/A',
      accountNo: 'N/A',
      ifscCode: 'N/A',
    },
    companyInfo: {
      address:
        '110, Ganesh glory, Godrej garden City road, jagatpur Ahmedabad - 382481',
      email: 'info@aluxerp.com',
      website: 'www.aluxerp.com',
    },
    logoUrl: logo,
    hasSurfaceTreatment: false,
    hasAnodising: false,
    hasPowderCoating: false,
    hasPVDF: false,
    hasEngineeringChildren: false,
    hasCutting: false,
    hasMachinings: false,
    hasDeburring: false,
    hasLaserChildren: false,
    hasLaserDescription: false,
    hasPrice: false,
    hasMillFinish: false,
    hasOutSource: false,
    hasOnlyMillFinish: false,
    hasThermalBreak: false,
  });

  const [invoiceData, setInvoiceData] = useState(getDefaultInvoiceData());

  const transformInvoiceData = useCallback((proformaData) => {
    setIsTransforming(true);

    try {
      if (!proformaData || !proformaData[0]) {
        return getDefaultInvoiceData();
      }

      const proforma = proformaData[0];

      const getJobWorkOrder = () => {
        const jobWorkOrder = [];
        const seenJobWorks = new Set();

        proforma?.proforma_details?.forEach(item => {
          if (Array.isArray(item.jobworks)) {
            item.jobworks.forEach(job => {
              if (!seenJobWorks.has(job)) {
                jobWorkOrder.push(job);
                seenJobWorks.add(job);
              }
            });
          }
        });

        return jobWorkOrder;
      };

      const jobWorkOrder = getJobWorkOrder();
      const hasSurfaceTreatment = proforma?.proforma_details?.some(item =>
        item.jobworks?.includes('Surface treatment'),
      );
      const hasAnodising = proforma?.proforma_details?.some(
        item => item.jobworks?.includes('Surface treatment') && item.anodising,
      );
      const hasPowderCoating = proforma?.proforma_details?.some(
        item =>
          item.jobworks?.includes('Surface treatment') && item.powder_coating,
      );
      const hasPVDF = proforma?.proforma_details?.some(
        item => item.jobworks?.includes('Surface treatment') && item.pvdf,
      );
      const hasEngineeringChildren = proforma?.proforma_details?.some(item =>
        item.jobworks?.includes('Engineering'),
      );
      const hasCutting = proforma?.proforma_details?.some(
        item => item.jobworks?.includes('Engineering') && item.cutting,
      );
      const hasMachinings = proforma?.proforma_details?.some(
        item => item.jobworks?.includes('Engineering') && item.machinings,
      );
      const hasDeburring = proforma?.proforma_details?.some(
        item => item.jobworks?.includes('Engineering') && item.deburring,
      );
      const hasLaserChildren = proforma?.proforma_details?.some(item =>
        item.jobworks?.includes('Laser marking'),
      );
      const hasLaserDescription = proforma?.proforma_details?.some(
        item =>
          item.jobworks?.includes('Laser marking') &&
          item.laser_marking_description,
      );
      const hasPrice = proforma?.proforma_details?.some(
        item =>
          item.jobworks?.includes('Laser marking') && item.laser_marking_price,
      );
      const hasMillFinish = proforma?.proforma_details?.some(item =>
        item.jobworks?.includes('Mill Finish'),
      );
      const hasOnlyMillFinish = proforma?.proforma_details?.every(item => {
        return (
          Array.isArray(item.jobworks) &&
          item.jobworks.length === 1 &&
          item.jobworks[0] === 'Mill Finish'
        );
      });

      const hasOutSource = proforma?.proforma_details?.some(item =>
        item.jobworks?.includes('Out Source'),
      );
      const hasThermalBreak = proforma?.proforma_details?.some(item =>
        item.jobworks?.includes('Thermal Break'),
      );

      if (!proforma.workorder) {
        console.error('Missing workorder data');
        return getDefaultInvoiceData();
      }

      if (!proforma.customer) {
        console.error('Missing customer data');
        return getDefaultInvoiceData();
      }

      const workorder = proforma.workorder;
      const customer = proforma.customer;

      const billToAddress = workorder?.bill_to?.office_address || {};
      const shipToAddress = workorder?.ship_to?.office_address || {};
      const bankDetails = customer?.customer_banking_details?.[0] || {};

      const transformedItems = (proforma.proforma_details || []).map(
        (detail, index) => {
          try {
            const workOrderDetail =
              workorder?.work_order_details?.[index] || {};
            return {
              sectionNo: detail?.profile_no?.die_number || 'N/A',
              imageUrl:
                detail?.profile_no?.die_diagram ||
                '/static/images/placeholder.jpg',
              description: buildDescription(detail?.profile_no),
              length: parseInt(detail?.length) || '0',
              quantity: {
                pieces: detail?.pieces || 0,
                weight: detail?.packed_weight || '0.000',
              },
              alloy: `${detail?.alloy?.alloy_code || 'N/A'} ${detail?.temper?.temper_code_new || ''}`,
              finish: workOrderDetail?.surface_finish || 'N/A',
              price: {
                itemRate: detail?.nalco_rate || '0.00',
                otherRate: Number(detail?.conversion)?.toFixed(2) || '0.00',
              },

              totalBasicAmount: Number(detail?.total_basic_amount)?.toFixed(2) || '0.00',
              gst: Number(detail?.gst_amount)?.toFixed(2) || '0.00',
              total: Number(detail?.total_amount)?.toFixed(2) || '0.00',
              jobworks: detail?.jobworks || [],
              anodising: detail?.anodising || false,
              anodising_price: detail?.anodising_price || '0.00',
              anodising_description: detail?.anodising_description || '',
              powder_coating: detail?.powder_coating || false,
              powder_coating_price: detail?.powder_coating_price || '0.00',
              powder_coating_description:
                detail?.powder_coating_description || '',
              pvdf: detail?.pvdf || false,
              pvdf_price: detail?.pvdf_price || '0.00',
              pvdf_description: detail?.pvdf_description || '',
              cutting: detail?.cutting || false,
              cutting_price: detail?.cutting_price || '0.00',
              machinings: detail?.machinings || false,
              machinings_price: detail?.machinings_price || '0.00',
              deburring: detail?.deburring || false,
              deburring_price: detail?.deburring_price || '0.00',
              laser_marking_description:
                detail?.laser_marking_description || '',
              laser_marking_price: detail?.laser_marking_price || '0.00',
              out_source: detail?.out_source || '0.00',
            };
          } catch (itemError) {
            console.error(`Error transforming item ${index}:`, itemError);
            return getDefaultItem(index);
          }
        },
      );

      const result = {
        date: proforma?.proforma_date || 'N/A',
        piNo: proforma?.proforma_no || 'N/A',
        poNo: workorder?.purchase_order_no || 'N/A',
        workOrderNo: proforma?.workorder_no || 'N/A',
        workOrderType: proforma?.workorder_type || '',
        jobWorks:
          proforma?.workorder_type === 'Job Work' &&
            proforma?.job_work?.job_work
            ? proforma.job_work.job_work
            : '',
        billTo: {
          name: customer?.person_name || 'N/A',
          company: customer?.customer_name || 'N/A',
          address: buildAddress(billToAddress),
        },
        shipTo: {
          name: workorder?.ship_to?.person_name || 'N/A',
          company: workorder?.ship_to?.customer_name || 'N/A',
          address: buildAddress(shipToAddress),
        },
        items: transformedItems,
        totals: {
          pieces: proforma?.summary?.total_pieces || '0',
          weight: proforma?.summary?.total_net_weight || '0.00',
          basicAmount: proforma?.summary?.total_basic_amount || '0.00',
          gst: proforma?.summary?.total_gst_amount || '0.00',
          total: proforma?.summary?.total_with_gst || '0.00',
        },
        freightCharges: proforma?.freight_charges || '0.00',
        advanceAmount: proforma?.advance_amount || '0.00',
        totalPayable: proforma?.summary?.total_payable_amount || '0.00',
        termsAndConditions: proforma?.terms_and_condition || '',
        bankDetails: {
          gstNo: customer?.gstin_number || 'N/A',
          bankName: bankDetails?.bank_name || 'N/A',
          branch: bankDetails?.bank_branch_address || 'N/A',
          accountNo: bankDetails?.bank_account_number || 'N/A',
          ifscCode: bankDetails?.bank_ifsc_code || 'N/A',
        },
        companyInfo: {
          address:
            '110, Ganesh glory, Godrej garden City road, jagatpur Ahmedabad - 382481',
          email: 'info@aluxerp.com',
          website: 'www.aluxerp.com',
        },
        logoUrl: logo,
        hasSurfaceTreatment,
        jobWorkOrder,
        hasAnodising,
        hasPowderCoating,
        hasPVDF,
        hasEngineeringChildren,
        hasCutting,
        hasMachinings,
        hasDeburring,
        hasLaserChildren,
        hasLaserDescription,
        hasPrice,
        hasMillFinish,

        hasOutSource,
        hasThermalBreak,
        hasOnlyMillFinish,
      };

      return result;
    } catch (error) {
      console.error('Error transforming invoice data:', error);
      return getDefaultInvoiceData();
    } finally {
      setIsTransforming(false);
    }
  }, []);

  useEffect(() => {
    if (activeProfileRecord) {
      setInvoiceData(
        transformInvoiceData([activeProfileRecord?.data])
      );
    }
  }, [activeProfileRecord, transformInvoiceData]);

  const surfaceTreatmentChildren = [];
  const EngineeringChildren = [];
  const LaserChildren = [];
  const millFinishChildren = [];
  const outSourceChildren = [];
  const thermalBreakChildren = [];

  if (invoiceData.hasAnodising) {
    surfaceTreatmentChildren.push(
      {
        title: 'Anodising Description',
        dataIndex: 'anodising_description',
        key: 'anodising_description',
        align: 'center',
        width: 70,
        render: (_, record) =>
          record.jobworks.includes('Surface treatment') && record.anodising
            ? _
            : null,
      },
      {
        title: 'Anodising Price',
        dataIndex: 'anodising_price',
        key: 'anodising_price',
        align: 'center',
        width: 60,
        render: (_, record) =>
          record.jobworks.includes('Surface treatment') && record.anodising
            ? _
            : null,
      },
    );
  }

  if (invoiceData.hasPowderCoating) {
    surfaceTreatmentChildren.push(
      {
        title: 'Powder Coating Description',
        dataIndex: 'powder_coating_description',
        key: 'powder_coating_description',
        align: 'center',
        width: 60,
        render: (_, record) =>
          record.jobworks.includes('Surface treatment') && record.powder_coating
            ? _
            : null,
      },
      {
        title: 'Powder Coating Price',
        dataIndex: 'powder_coating_price',
        key: 'powder_coating_price',
        align: 'center',
        width: 60,
        render: (_, record) =>
          record.jobworks.includes('Surface treatment') && record.powder_coating
            ? _
            : null,
      },
    );
  }

  if (invoiceData.hasPVDF) {
    surfaceTreatmentChildren.push(
      {
        title: 'PVDF Description',
        dataIndex: 'pvdf_description',
        key: 'pvdf_description',
        align: 'center',
        width: 60,
        render: (_, record) =>
          record.jobworks.includes('Surface treatment') && record.pvdf
            ? _
            : null,
      },
      {
        title: 'PVDF Price',
        dataIndex: 'pvdf_price',
        key: 'pvdf_price',
        align: 'center',
        width: 55,
        render: (_, record) =>
          record.jobworks.includes('Surface treatment') && record.pvdf
            ? _
            : null,
      },
    );
  }

  if (invoiceData.hasCutting) {
    EngineeringChildren.push({
      title: 'Cutting Price',
      dataIndex: 'cutting_price',
      key: 'cutting_price',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Engineering') && record.cutting ? _ : null,
    });
  }

  if (invoiceData.hasMachinings) {
    EngineeringChildren.push({
      title: 'Machinings Price',
      dataIndex: 'machinings_price',
      key: 'machinings_price',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Engineering') && record.machinings ? _ : null,
    });
  }

  if (invoiceData.hasDeburring) {
    EngineeringChildren.push({
      title: 'Deburring Price',
      dataIndex: 'deburring_price',
      key: 'deburring_price',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Engineering') && record.deburring ? _ : null,
    });
  }

  if (invoiceData.hasLaserDescription) {
    LaserChildren.push({
      title: 'Laser Marking Description',
      dataIndex: 'laser_marking_description',
      key: 'laser_marking_description',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Laser marking') &&
          record.laser_marking_description
          ? _
          : null,
    });
  }

  if (invoiceData.hasPrice) {
    LaserChildren.push({
      title: 'Laser Marking Price',
      dataIndex: 'laser_marking_price',
      key: 'laser_marking_price',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Laser marking') && record.laser_marking_price
          ? _
          : null,
    });
  }

  if (invoiceData.hasMillFinish) {
    millFinishChildren.push({
      title: 'Mill Finish',
      dataIndex: 'mill_finish',
      key: 'mill_finish',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Mill Finish') ? _ || 'Yes' : null,
    });
  }

  if (invoiceData.hasOutSource) {
    outSourceChildren.push({
      title: 'Out Source',
      dataIndex: 'out_source',
      key: 'out_source',
      align: 'center',
      width: 60,
    });
  }

  if (invoiceData.hasThermalBreak) {
    thermalBreakChildren.push({
      title: 'Thermal Break',
      dataIndex: 'thermal_break',
      key: 'thermal_break',
      align: 'center',
      width: 60,
      render: (_, record) =>
        record.jobworks.includes('Thermal Break') ? _ || 'Yes' : null,
    });
  }

  const buildDescription = profileNo => {
    if (!profileNo) return 'N/A';

    const dims = [
      profileNo.dimension1,
      profileNo.dimension2,
      profileNo.dimension3,
      profileNo.dimension4,
    ];

    // Filter out invalid / empty / zero dimensions
    const validDims = dims.filter(
      d => d && d !== '0' && d !== '0.00'
    );

    // Join with " X " and add "MM"
    return validDims.length
      ? validDims.map(d => `${d} MM`).join(' X ')
      : 'N/A';
  };

  const buildAddress = address => {
    if (!address) return 'N/A';

    const parts = [
      address.shop,
      address.area,
      address.landmark,
      address.city,
      address.state,
      address.country,
    ].filter(Boolean);

    const addressStr = parts.join(', ');
    const pinCode = address.pin_code ? ` - ${address.pin_code}` : '';

    return addressStr + pinCode || 'N/A';
  };

  const getDefaultItem = index => ({
    sectionNo: 'N/A',
    imageUrl: '/static/images/placeholder.jpg',
    description: 'N/A',
    length: '0',
    quantity: {
      pieces: 0,
      weight: '0.000',
    },
    alloy: 'N/A',
    finish: 'N/A',
    price: {
      itemRate: '0.00',
      otherRate: '0.00',
    },
    totalBasicAmount: '0.00',
    gst: '0.00',
    total: '0.00',
    jobworks: [],
    anodising: false,
    anodising_price: '0.00',
    anodising_description: '',
    powder_coating: false,
    powder_coating_price: '0.00',
    powder_coating_description: '',
    pvdf: false,
    pvdf_price: '0.00',
    pvdf_description: '',
    cutting: false,
    cutting_price: '0.00',
    machinings: false,
    machinings_price: '0.00',
    deburring: false,
    deburring_price: '0.00',
    laser_marking_description: '',
    laser_marking_price: '0.00',
    mill_finish: '',
    out_source: '',
    thermal_break: '',
  });

  if (status === 'loading') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '300px',
        }}
      >
        <div style={{ fontSize: '18px' }}>Loading proforma data...</div>
      </div>
    );
  }

  if (status === 'failed') {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '300px',
        }}
      >
        <div style={{ fontSize: '18px', color: '#dc2626' }}>
          Failed to load proforma data
        </div>
      </div>
    );
  }

  if (isTransforming) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '300px',
        }}
      >
        <div style={{ fontSize: '18px' }}>Processing data...</div>
      </div>
    );
  }

  const {
    date,
    piNo,
    poNo,
    workOrderNo,
    items,
    totals,
    freightCharges,
    advanceAmount,
    totalPayable,
    termsAndConditions,
    workOrderType,
    jobWorks,
  } = invoiceData;
  const jobWorkMap = {
    'Surface treatment': {
      has: invoiceData.hasSurfaceTreatment,
      colSpan: surfaceTreatmentChildren.length,
      label: 'Surface Treatment',
      children: surfaceTreatmentChildren,
    },
    Engineering: {
      has: invoiceData.hasEngineeringChildren,
      colSpan: EngineeringChildren.length,
      label: 'Engineering',
      children: EngineeringChildren,
    },
    'Laser marking': {
      has: invoiceData.hasLaserChildren,
      colSpan: LaserChildren.length,
      label: 'Laser Marking',
      children: LaserChildren,
    },
    'Mill Finish': {
      has: invoiceData.hasMillFinish,
      colSpan: 1,
      label: 'Mill Finish',
      children: millFinishChildren,
      rowSpan: 2,
    },
    'Out Source': {
      has: invoiceData.hasOutSource,
      colSpan: 1,
      label: 'Out Source',
      children: outSourceChildren,
      rowSpan: 2,
    },
    'Thermal Break': {
      has: invoiceData.hasThermalBreak,
      colSpan: 1,
      label: 'Thermal Break',
      children: thermalBreakChildren,
      rowSpan: 2,
    },
  };

  return (
    <div>
      <div className="invoice-container">
        <div className="header-section">
          <div className="logo-section">
             <CompanyLogo logoUrl={companyLogo} />
          </div>
          <div className="title-section">
            <h1 className="invoice-title">Proforma Invoice</h1>
          </div>
        </div>

        <div className="info-section">
          <div className="info-left">
            <table className="info-table">
              <tbody>
                <tr>
                  <td className="info-label">Date :</td>
                  <td>{dayjs(date).format('DD-MM-YYYY')}</td>
                </tr>
                <tr>
                  <td className="info-label">PI No. :</td>
                  <td>{piNo}</td>
                </tr>
                <tr>
                  <td className="info-label">PO No. :</td>
                  <td>{poNo}</td>
                </tr>
                <tr>
                  <td className="info-label">WorkOrder No. :</td>
                  <td>{workOrderNo}</td>
                </tr>
                {workOrderType === 'Job Work' && jobWorks && (
                  <tr>
                    <td className="info-label">Job Work :</td>
                    <td>{jobWorks}</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        <div className="address-section">
          <div className="address-box">
            <div className="address-header">Bill To</div>
            <div className="address-content">
              <strong>{workOrderDetail?.bill_to?.person_name}</strong>
              <br />
              <strong>{workOrderDetail?.bill_to?.customer_name}</strong>
              <br />
              {[
                workOrderDetail?.bill_to?.factory_address?.area,
                workOrderDetail?.bill_to?.factory_address?.city,
                workOrderDetail?.bill_to?.factory_address?.country,
                workOrderDetail?.bill_to?.factory_address?.landmark,
                workOrderDetail?.bill_to?.factory_address?.pin_code,
                workOrderDetail?.bill_to?.factory_address?.state,
              ]
                .filter(
                  part =>
                    part && part.toLowerCase() !== 'na' && part.trim() !== '',
                )
                .join(' ')}
            </div>
          </div>
          <div className="address-box">
            <div className="address-header">Ship To (if Different)</div>
            <div className="address-content">
              <strong>{workOrderDetail?.bill_to?.person_name}</strong>
              <br />
              <strong>{workOrderDetail?.bill_to?.customer_name}</strong>
              <br />
              {[
                workOrderDetail?.ship_to?.factory_address?.area,
                workOrderDetail?.ship_to?.factory_address?.city,
                workOrderDetail?.ship_to?.factory_address?.country,
                workOrderDetail?.ship_to?.factory_address?.landmark,
                workOrderDetail?.ship_to?.factory_address?.pin_code,
                workOrderDetail?.ship_to?.factory_address?.state,
              ]
                .filter(
                  part =>
                    part && part.toLowerCase() !== 'na' && part.trim() !== '',
                )
                .join(' ')}
            </div>
          </div>
        </div>

        <table className="main-table scaled-print-table">
          <thead>
            <tr>
              <th rowSpan="3">SR NO.</th>
              <th rowSpan="3">PROFILE NO.</th>
              <th rowSpan="3">IMAGE</th>
              <th rowSpan="3">
                DESCRIPT
                <br />
                ION
              </th>
              <th rowSpan="3">LENGTH</th>
              <th colSpan="2">QUANTITY</th>
              <th rowSpan="3">
                <>
                  ALLOY/
                  <br />
                  TEMP-GRADE
                </>
              </th>

              {!invoiceData?.hasOnlyMillFinish &&
                (invoiceData.hasSurfaceTreatment ||
                  invoiceData.hasEngineeringChildren ||
                  invoiceData.hasLaserChildren ||
                  invoiceData.hasMillFinish ||
                  invoiceData.hasOutSource ||
                  invoiceData.hasThermalBreak) && (
                  <th
                    colSpan={
                      (invoiceData.hasSurfaceTreatment
                        ? surfaceTreatmentChildren.length
                        : 0) +
                      (invoiceData.hasEngineeringChildren
                        ? EngineeringChildren.length
                        : 0) +
                      (invoiceData.hasLaserChildren
                        ? LaserChildren.length
                        : 0) +
                      (invoiceData.hasMillFinish ? 1 : 0) +
                      (invoiceData.hasOutSource ? 1 : 0) +
                      (invoiceData.hasThermalBreak ? 1 : 0)
                    }
                  >
                    Job Work
                  </th>
                )}

              <th colSpan="2">PRICE / KGS</th>
              <th rowSpan="3">TOTAL BASIC AMOUNT (Rs.)</th>
              <th colSpan="1">GST(Rs.)</th>
              <th rowSpan="3">TOTAL (Rs.)</th>
            </tr>

            <tr>
              <th rowSpan="2">PIECES</th>
              <th rowSpan="2">WEIGHT(kg.)</th>
              {!invoiceData?.hasOnlyMillFinish &&
                invoiceData?.jobWorkOrder?.map(jobName => {
                  const job = jobWorkMap[jobName];
                  if (!job || !job.has) return null;
                  return (
                    <th
                      key={jobName}
                      colSpan={job.colSpan}
                      rowSpan={job.rowSpan || undefined}
                    >
                      {job.label}
                    </th>
                  );
                })}

              <th rowSpan="2">Item Rate(Rs.)</th>
              <th rowSpan="2">Other Rate</th>
              <th rowSpan="2">IGST(18%)</th>
            </tr>
            <tr>

              {!invoiceData?.hasOnlyMillFinish &&
                invoiceData?.jobWorkOrder?.map(jobName => {
                  const job = jobWorkMap[jobName];
                  if (!job || !job.has || job.rowSpan) return null;
                  return job.children.map((child, idx) => (
                    <th key={`${jobName}-${idx}`}>{child.title}</th>
                  ));
                })}
            </tr>
          </thead>
          <tbody>
            {items.length > 0 ? (
              items.map((item, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{item.sectionNo}</td>
                  <td>
                    {typeof item.imageUrl !== 'string' ||
                      !item.imageUrl.startsWith('https://') ? (
                      ''
                    ) : (
                      <img
                        src={item.imageUrl}
                        alt="Section"
                        className="section-image"
                        onError={e => {
                          if (!e.target.src.includes('placeholder.jpg')) {
                            e.target.src = '/static/images/placeholder.jpg';
                          }
                        }}
                      />
                    )}
                  </td>
                  <td>{item.description}</td>
                  <td>{item.length}</td>
                  <td>{item.quantity.pieces}</td>
                  <td>{item.quantity.weight}</td>
                  <td>{item.alloy}</td>
                  {!invoiceData?.hasOnlyMillFinish &&
                    invoiceData?.jobWorkOrder?.map(jobName => {
                      const job = jobWorkMap[jobName];
                      if (!job || !job.has) return null;
                      if (job.children && job.children.length > 0) {
                        return job.children.map((child, idx) => (
                          <td key={`${jobName}-data-${idx}`}>
                            {child.render
                              ? child.render(item[child.dataIndex], item)
                              : child?.title === 'Out Source' &&
                                item[child.dataIndex] !== 0.0
                                ? 'No'
                                : item[child.dataIndex] || '-'}
                          </td>
                        ));
                      }

                      return (
                        <td key={`${jobName}-data`}>
                          {jobName === 'Mill Finish'
                            ? item.jobwork.includes('Mill Finish')
                              ? 'Yes'
                              : '-'
                            : jobName === 'Out Source'
                              ? String(item.out_source) === 'true'
                                ? 'Yes'
                                : 'No'
                              : jobName === 'Thermal Break'
                                ? item.jobwork.includes('Thermal Break')
                                  ? 'Yes'
                                  : '-'
                                : '-'}
                        </td>
                      );
                    })}
                  <td>{item.price.itemRate}</td>
                  <td>{item.price.otherRate}</td>
                  <td>{item.totalBasicAmount}</td>
                  <td>{item.gst}</td>
                  <td>{item.total}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={
                    8 +
                    (invoiceData.hasSurfaceTreatment
                      ? surfaceTreatmentChildren.length
                      : 0) +
                    (invoiceData.hasEngineeringChildren
                      ? EngineeringChildren.length
                      : 0) +
                    (invoiceData.hasLaserChildren ? LaserChildren.length : 0) +
                    (invoiceData.hasMillFinish ? 1 : 0) +
                    (invoiceData.hasOutSource ? 1 : 0) +
                    (invoiceData.hasThermalBreak ? 1 : 0) +
                    5
                  }
                  style={{ textAlign: 'center', padding: '20px' }}
                >
                  No items available
                </td>
              </tr>
            )}

            {items.length > 0 &&
              (() => {
                const totalColumns =
                  8 +
                  (!invoiceData?.hasOnlyMillFinish
                    ? (invoiceData.hasSurfaceTreatment
                      ? surfaceTreatmentChildren.length
                      : 0) +
                    (invoiceData.hasEngineeringChildren
                      ? EngineeringChildren.length
                      : 0) +
                    (invoiceData.hasLaserChildren
                      ? LaserChildren.length
                      : 0) +
                    (invoiceData.hasMillFinish ? 1 : 0) +
                    (invoiceData.hasOutSource ? 1 : 0) +
                    (invoiceData.hasThermalBreak ? 1 : 0)
                    : 0) +
                  5;

                const jobWorkColspan = totalColumns - 10;

                return (
                  <>
                    <tr className="total-row">
                      <td colSpan="5">Total :</td>
                      <td>{totals.pieces} Nos.</td>
                      <td>{totals.weight} Kg.</td>
                      <td colSpan={jobWorkColspan}></td>
                      <td>{totals.basicAmount}</td>
                      <td>{totals.gst}</td>
                      <td>{totals.total}</td>
                    </tr>
                    <tr>
                      <td colSpan={totalColumns - 2}></td>
                      <td>
                        <b>Freight Charges :</b>
                      </td>
                      <td>
                        <b>{freightCharges}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={totalColumns - 2}></td>
                      <td>
                        <b>Advance Amount :</b>
                      </td>
                      <td>
                        <b>- {advanceAmount}</b>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan={totalColumns - 2}></td>
                      <td>
                        <b>Total Payable Amount :</b>
                      </td>
                      <td>
                        <b>{totalPayable}</b>
                      </td>
                    </tr>
                  </>
                );
              })()}
          </tbody>
        </table>

        <div className="footer-section">
          <div className="bank-box" style={{ maxHeight: '200px' }}>
            <div className="bank-header">Bank Details</div>
            <div className="bank-content">
              <strong>GST No. :</strong> 24AADCH4808D1Z0 <br />
              <strong>Bank Details :</strong>
              <br />
              <strong>Name :</strong> {settingData?.financial_settings?.bank_name ?? 'N/A'}
              <br />
              <strong>Branch :</strong> {settingData?.financial_settings?.bank_address ?? 'N/A'}
              <br />
              <strong>A/C No. :</strong> {settingData?.financial_settings?.account_number ?? 'N/A'} <br />
              <strong>IFSC code :</strong> {settingData?.financial_settings?.ifsc_code ?? 'N/A'}
            </div>
          </div>
        </div>
        <div className="signature-section">
          <div className="signature-box">Prepared By</div>
          <div className="signature-box">
            Authorised Signatory
            <br />
           ({settingData?.company_settings?.company_name})
          </div>
        </div>
      </div>

      <div className="terms-fullpage">
        <h2
          style={{
            textAlign: 'center',
            color: '#2c5aa0',
            marginBottom: 10,
            fontSize: '14px',
          }}
        >
          Terms and Conditions
        </h2>
        <div
          className="terms-content"
          dangerouslySetInnerHTML={{
            __html:
              typeof termsAndConditions === 'string'
                ? termsAndConditions
                  .replace(/<p>( |\s)*<\/p>/gi, '')
                  .replace(/\s+/g, ' ')
                  .trim() || 'Terms and conditions not available'
                : 'Terms and conditions not available',
          }}
        />

        <button className="print-button" onClick={() => window.print()}>
          Print
        </button>
      </div>
    </div>
  );
}

export default PrintProforma;
